
import React from 'react';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { format } from 'date-fns';
import { SalesData } from '@/utils/licenseService';

interface SalesTableGroupedBySuperAdminProps {
  filteredData: SalesData[];
}

const SalesTableGroupedBySuperAdmin: React.FC<SalesTableGroupedBySuperAdminProps> = ({ filteredData }) => {
  // Group data by Super Admin
  const groupedData = filteredData.reduce((groups, sale) => {
    const key = sale.superAdminId;
    if (!groups[key]) {
      groups[key] = {
        name: sale.superAdminName,
        sales: [],
        total: 0
      };
    }
    groups[key].sales.push(sale);
    groups[key].total += sale.amount;
    return groups;
  }, {} as Record<string, { name: string; sales: SalesData[]; total: number }>);

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Request #</TableHead>
            <TableHead>Fulfillment #</TableHead>
            <TableHead>Super Admin</TableHead>
            <TableHead>Instance</TableHead>
            <TableHead>Plan</TableHead>
            <TableHead>Date</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Type</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {Object.entries(groupedData).map(([id, group]) => (
            <React.Fragment key={id}>
              <TableRow className="bg-muted/30">
                <TableCell colSpan={8} className="font-bold">
                  {group.name}
                </TableCell>
                <TableCell className="font-bold text-right">
                  ${group.total}
                </TableCell>
              </TableRow>
              {group.sales.map(sale => (
                <TableRow key={sale.id}>
                  <TableCell className="font-medium text-blue-600">
                    {sale.requestOrderNumber || `RO${sale.invoiceId.substring(4)}`}
                  </TableCell>
                  <TableCell className="font-medium text-green-600">
                    {sale.fulfillmentOrderNumber || `RSO${sale.invoiceId.substring(4)}`}
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>{sale.instanceName || 'N/A'}</TableCell>
                  <TableCell>
                    <div>{sale.planName}</div>
                    <div className="text-sm text-gray-500 capitalize">{sale.billingCycle}</div>
                  </TableCell>
                  <TableCell>{format(new Date(sale.date), 'MM/dd/yyyy')}</TableCell>
                  <TableCell>${sale.amount}</TableCell>
                  <TableCell>
                    <Badge
                      variant={
                        sale.status === 'paid' ? 'default' :
                        sale.status === 'pending' ? 'outline' : 'destructive'
                      }
                    >
                      {sale.status.charAt(0).toUpperCase() + sale.status.slice(1)}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    <Badge variant="secondary">
                      {sale.isRecurring ? 'Recurring' : 'New'}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default SalesTableGroupedBySuperAdmin;
